import { Slider } from './Slider.tsx';
import { cn } from '@keyslabor/documents/src/lib/utils.ts';

interface VideoPlayerSliderProps {
  currentTime: number;
  duration: number;
  onTimeChange: (time: number) => void;
}

function formatTime(time: number): string {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes.toString().padStart(2, '0')}:${seconds
    .toString()
    .padStart(2, '0')}`;
}

export function VideoPlayerSlider({
  currentTime,
  duration,
  onTimeChange,
}: VideoPlayerSliderProps) {
  return (
    <div
      className={cn(
        'w-full max-w-md mx-auto px-[10px] h-[38px]',
        'bg-gradient-to-b from-transparent to-black/60'
      )}
    >
      <div className="flex justify-between text-sm text-white items-center gap-[10px]">
        <span>{formatTime(currentTime)}</span>
        <span>{formatTime(duration)}</span>
      </div>
      <Slider
        min={0}
        max={duration}
        value={currentTime}
        onChange={onTimeChange}
        className="mb-0 mt-1 flex-1"
      />
    </div>
  );
}
